import React, {Component} from "react";
import {Link} from "react-router-dom";
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {LayoutSidebar} from "../../Layout";
import {Spinner} from "../Spinner";
import {FaIcon} from "../FaIcon";
import {Switch} from "../buttons/Swtich";
import {LocalStorage} from "../../utils/LocalStorage";
import {ReportCard} from "./ReportCard";
import {ReportContextSelector} from "./ReportContextSelector";
import {AgencyClientSelect} from "../selects/AgencyClientSelect";
import {ClientProfileSidePanel} from "../client/ClientProfileSidePanel";
import {ReportPreGenerationWizard} from './ReportPreGenerationWizard';
import {withTranslation} from 'react-i18next';
import '../client/ClientReportsContent.scss';
import './AllReportsPage.scss';


class AllReportsPageClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reports: [],
            loading: true,
            generating: false,
            showGenerateModal: false,
            showSuccessModal: false,
            selectedClientId: null,
            selectedClientName: null,
            allAgencyClients: [],
            loadingClients: false,
            templates: [],
            loadingTemplates: false,
            selectedTemplateSlug: null,
            userTemplates: [],
            selectedUserTemplateId: null,
            profilePanelClientId: null,
            profilePanelClientName: null,
            visibleToClients: true,
            isPublic: true,
            scope: null,
            clientData: null,
            loadingClientData: false,
            showWizard: false,
        };

        this.pollingInterval = null;
        this.handleDelete = this.handleDelete.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleToggleVisibility = this.handleToggleVisibility.bind(this);
        this.toggleGenerateModal = this.toggleGenerateModal.bind(this);
        this.toggleSuccessModal = this.toggleSuccessModal.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
        this.handleSelectTemplate = this.handleSelectTemplate.bind(this);
        this.handleSelectUserTemplate = this.handleSelectUserTemplate.bind(this);
        this.handleGenerate = this.handleGenerate.bind(this);
        this.proceedWithGenerate = this.proceedWithGenerate.bind(this);
        this.handleClientNameClick = this.handleClientNameClick.bind(this);
        this.closeProfilePanel = this.closeProfilePanel.bind(this);
        this.handleScopeChange = this.handleScopeChange.bind(this);
    }

    componentDidMount() {
        this.fetchReports();
    }

    componentWillUnmount() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }

    startPollingIfNeeded(reports) {
        const hasProcessing = reports.some(r => r.status === 'PROCESSING');
        if (hasProcessing && !this.pollingInterval) {
            this.pollingInterval = setInterval(() => this.fetchReports(), 30000);
        } else if (!hasProcessing && this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }

    fetchReports() {
        this.setState({loading: this.state.reports.length === 0});
        new APIClient(API_URL + 'reports/').call('GET').then((data) => {
            if (data && data.status === 'OK') {
                const reports = data.data.reports || [];
                this.setState({reports, loading: false}, () => {
                    this.startPollingIfNeeded(reports);
                });
            } else {
                this.setState({loading: false});
            }
        });
    }

    fetchClients() {
        this.setState({loadingClients: true});
        new APIClient(API_URL + 'clients/').call('GET').then((data) => {
            if (data && data.data) {
                this.setState({allAgencyClients: data.data, loadingClients: false});
            } else {
                this.setState({loadingClients: false});
            }
        });
    }

    toggleGenerateModal() {
        const opening = !this.state.showGenerateModal;
        this.setState({
            showGenerateModal: opening,
            selectedClientId: null,
            selectedClientName: null,
            templates: [],
            loadingTemplates: false,
            selectedTemplateSlug: null,
            userTemplates: [],
            selectedUserTemplateId: null,
            visibleToClients: true,
            isPublic: true,
            scope: null,
            clientData: null,
            loadingClientData: false,
            showWizard: false,
        });
        if (opening && this.state.allAgencyClients.length === 0) {
            this.fetchClients();
        }
    }

    toggleSuccessModal() {
        this.setState({showSuccessModal: !this.state.showSuccessModal});
    }

    handleClientChange(clientId, clientName) {
        this.setState({
            selectedClientId: clientId,
            selectedClientName: clientName,
            templates: [],
            loadingTemplates: true,
            selectedTemplateSlug: null,
            userTemplates: [],
            selectedUserTemplateId: null,
            scope: null,
            clientData: null,
            loadingClientData: false,
        });
        if (clientId) {
            new APIClient(API_URL + 'reports/templates/?client_id=' + clientId).call('GET').then((data) => {
                if (this.state.selectedClientId !== clientId) return;
                if (data && data.status === 'OK') {
                    const templates = data.data.templates || [];
                    const compatible = templates.filter(t => t.is_compatible);
                    const selectedTemplateSlug = compatible.length === 1 ? compatible[0].slug : null;
                    this.setState({templates, loadingTemplates: false, selectedTemplateSlug});
                } else {
                    this.setState({templates: [], loadingTemplates: false});
                }
            });
            new APIClient(API_URL + 'reports/templates/user/').call('GET').then((data) => {
                if (this.state.selectedClientId !== clientId) return;
                if (data && data.status === 'OK') {
                    this.setState({userTemplates: data.data.user_templates || []});
                }
            });
        }
    }

    handleClientNameClick(clientId, clientName) {
        this.setState({profilePanelClientId: clientId, profilePanelClientName: clientName});
    }

    closeProfilePanel() {
        this.setState({profilePanelClientId: null, profilePanelClientName: null});
    }

    handleSelectTemplate(slug) {
        const template = this.state.templates.find(t => t.slug === slug);
        if (template && template.is_compatible) {
            this.setState({selectedTemplateSlug: slug, selectedUserTemplateId: null, scope: null}, () => {
                if (template.allows_item_selection && !this.state.clientData && this.state.selectedClientId) {
                    this.setState({loadingClientData: true});
                    new APIClient(API_URL + 'client/' + this.state.selectedClientId).call('GET').then((data) => {
                        if (data && data.status === 'OK') {
                            this.setState({clientData: data.data, loadingClientData: false});
                        } else {
                            this.setState({loadingClientData: false});
                        }
                    });
                }
            });
        }
    }

    handleSelectUserTemplate(templateId) {
        this.setState({selectedUserTemplateId: templateId, selectedTemplateSlug: null, scope: null});
    }

    handleScopeChange(scope) {
        this.setState({scope});
    }

    handleGenerate() {
        const {selectedClientId, selectedTemplateSlug, selectedUserTemplateId} = this.state;
        if (!selectedClientId || (!selectedTemplateSlug && !selectedUserTemplateId)) return;

        if (selectedUserTemplateId) {
            this.proceedWithGenerate();
            return;
        }

        this.setState({showWizard: true});
    }

    proceedWithGenerate() {
        const {selectedClientId, selectedTemplateSlug, selectedUserTemplateId, visibleToClients, isPublic, scope} = this.state;

        this.setState({generating: true, showGenerateModal: false, showWizard: false});
        const body = {
            action_type: 'template_report',
            client_id: selectedClientId,
            is_visible_to_clients: visibleToClients,
            is_public: isPublic,
            data_source_type: scope?.data_source_type || null,
            ad_account_id: scope?.ad_account_id || null,
            business_unit_id: scope?.business_unit_id || null,
        };
        if (selectedUserTemplateId) {
            body.user_template_id = selectedUserTemplateId;
        } else {
            body.template_slug = selectedTemplateSlug;
        }
        new APIClient(API_URL + 'agent/trigger-action/').call('POST', body).then((data) => {
            this.setState({generating: false});
            if (data && data.status === 'OK') {
                const newReport = {
                    report_id: data.data.report_id,
                    title: this.props.t('client_reports.generating'),
                    generated_at: new Date().toISOString(),
                    status: 'PROCESSING',
                    url: null,
                    block_count: 0,
                    can_delete: true,
                    client_name: this.state.selectedClientName,
                    client_id: this.state.selectedClientId,
                };
                this.setState(prevState => ({
                    reports: [newReport, ...prevState.reports],
                    showSuccessModal: true,
                }), () => {
                    this.startPollingIfNeeded(this.state.reports);
                });
            } else if (data) {
                const {t} = this.props;
                if (data.status === 'ALREADY_PROCESSING') {
                    alert(t('client_reports.error_already_processing'));
                } else {
                    alert(data.error_message || 'Error');
                }
            }
        });
    }

    handleDelete(reportId) {
        const {t} = this.props;
        if (!window.confirm(t('client_reports.delete_confirm'))) return;

        new APIClient(API_URL + 'reports/' + reportId + '/').call('DELETE').then((data) => {
            if (data && data.status === 'OK') {
                this.setState(prevState => ({
                    reports: prevState.reports.filter(r => r.report_id !== reportId),
                }));
            } else if (data && data.status === 'FORBIDDEN') {
                alert(t('client_reports.delete_forbidden'));
            }
        });
    }

    handleCancel(reportId) {
        const {t} = this.props;
        if (!window.confirm(t('client_reports.cancel_confirm'))) return;

        new APIClient(API_URL + 'reports/' + reportId + '/').call('DELETE').then((data) => {
            if (data && (data.status === 'OK' || data.status === 'FORBIDDEN')) {
                this.fetchReports();
            }
        });
    }

    handleToggleVisibility(reportId, updates) {
        new APIClient(API_URL + 'reports/' + reportId + '/').call('PATCH', updates).then((data) => {
            if (data && data.status === 'OK') {
                this.setState(prevState => ({
                    reports: prevState.reports.map(r =>
                        r.report_id === reportId ? {...r, ...updates} : r
                    ),
                }));
            }
        });
    }

    renderContent() {
        const {t} = this.props;
        const {reports, loading} = this.state;

        if (loading) {
            return (
                <div className="client-reports-loading">
                    <Spinner color="positive"/>
                </div>
            );
        }

        if (reports.length === 0) {
            return (
                <div className="client-reports-empty">
                    <div className="client-reports-empty-icon">
                        <FaIcon iconName="wand-magic-sparkles" />
                    </div>
                    <h3 className="client-reports-empty-title">{t('all_reports.no_reports')}</h3>
                    <p className="client-reports-empty-subtitle">{t('all_reports.empty_subtitle')}</p>
                    <button
                        className="btn -alt client-reports-empty-cta"
                        onClick={this.toggleGenerateModal}
                    >
                        <FaIcon iconName="plus" />
                        {t('all_reports.generate_report')}
                    </button>
                </div>
            );
        }

        return (
            <div className="client-reports-list">
                {reports.map(report => (
                    <ReportCard
                        key={report.report_id}
                        report={report}
                        onDelete={this.handleDelete}
                        onCancel={this.handleCancel}
                        onToggleVisibility={this.handleToggleVisibility}
                        showClientName={true}
                        onClientNameClick={this.handleClientNameClick}
                        t={t}
                        language={this.props.i18n.language}
                    />
                ))}
            </div>
        );
    }

    render() {
        const {t} = this.props;
        const {generating, showGenerateModal, showSuccessModal, selectedClientId, selectedTemplateSlug, selectedUserTemplateId} = this.state;
        const hasProcessing = this.state.reports.some(r => r.status === 'PROCESSING');
        const hasSelection = !!selectedTemplateSlug || !!selectedUserTemplateId;

        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content">
                    <header className="section-header">
                        <h1 className="section-title">{t('all_reports.title')}</h1>
                        <Link to="/reports/templates" className="all-reports-templates-link">
                            <FaIcon iconName="file-chart-line"/>
                            {t('all_reports.my_templates')}
                        </Link>
                    </header>
                    <div className="section-body">
                        <div className="box client-reports-box">
                            <header className="client-reports-box-header">
                                <div className="client-reports-header-content">
                                    <h2 className="client-reports-title">{t('all_reports.title')}</h2>
                                    <p className="client-reports-subtitle">{t('all_reports.subtitle')}</p>
                                </div>
                                <div className="client-reports-generate-btn">
                                    <button
                                        className="btn -alt"
                                        onClick={this.toggleGenerateModal}
                                        disabled={generating || hasProcessing}
                                    >
                                        <FaIcon iconName="wand-magic-sparkles" />
                                        {t('all_reports.generate_report')}
                                    </button>
                                </div>
                            </header>
                            {this.renderContent()}
                        </div>
                    </div>
                </section>

                <Modal isOpen={showGenerateModal} toggle={this.toggleGenerateModal} className="all-reports-generate-modal">
                    <ModalHeader toggle={this.toggleGenerateModal}>
                        {t('reports.generate_report')}
                    </ModalHeader>
                    <ModalBody className="all-reports-generate-modal-body">
                        <div className="generate-modal-section">
                            <label className="generate-modal-label">{t('all_reports.client_label')}</label>
                            <AgencyClientSelect
                                allAgencyClients={this.state.allAgencyClients}
                                selectedAgencyClient={selectedClientId}
                                onAgencyClientChange={this.handleClientChange}
                                canCreateNewAgencyClient={false}
                                hideGoToAgencyClientsAssignment={true}
                                loading={this.state.loadingClients}
                            />
                        </div>

                        {selectedClientId && (
                            <div className="generate-modal-section -templates">
                                <label className="generate-modal-label">{t('reports.select_template')}</label>
                                {this.state.loadingTemplates ? (
                                    <div className="generate-modal-templates-loading">
                                        <Spinner color="positive" size="sm"/>
                                    </div>
                                ) : (
                                    <div className="generate-modal-templates-list">
                                        {this.state.templates.length > 0 && this.state.userTemplates.length > 0 && (
                                            <div className="generate-modal-templates-section-header">
                                                {t('templates.picker_section_official')}
                                            </div>
                                        )}
                                        {this.state.templates.map(template => {
                                            const isSelected = selectedTemplateSlug === template.slug;
                                            const isDisabled = !template.is_compatible;
                                            let className = 'generate-modal-template-card';
                                            if (isSelected) className += ' -selected';
                                            if (isDisabled) className += ' -disabled';
                                            return (
                                                <div key={template.slug} className={className}
                                                     onClick={() => !isDisabled && this.handleSelectTemplate(template.slug)}>
                                                    <div className="generate-modal-template-icon">
                                                        <FaIcon iconName={template.icon || 'file-chart-line'}/>
                                                    </div>
                                                    <div className="generate-modal-template-content">
                                                        <h4 className="generate-modal-template-name">{template.name}</h4>
                                                        <p className="generate-modal-template-desc">{template.description}</p>
                                                        <div className="generate-modal-template-meta">
                                                            <span className="generate-modal-template-meta-badge">
                                                                <FaIcon iconName={template.data_source_level === 'AD_ACCOUNTS' ? 'bullhorn' : 'chart-pie'}/>
                                                                {template.data_source_level === 'AD_ACCOUNTS'
                                                                    ? t('reports.meta_ad_accounts')
                                                                    : t('reports.meta_bus')}
                                                            </span>
                                                            <span className="generate-modal-template-meta-scope">
                                                                {template.allows_item_selection
                                                                    ? (template.data_source_level === 'AD_ACCOUNTS'
                                                                        ? t('reports.meta_scope_select_account')
                                                                        : t('reports.meta_scope_select_bu'))
                                                                    : (template.data_source_level === 'AD_ACCOUNTS'
                                                                        ? t('reports.meta_scope_all_accounts')
                                                                        : t('reports.meta_scope_all_bus'))}
                                                            </span>
                                                        </div>
                                                        {isDisabled && template.incompatible_reasons.length > 0 && (
                                                            <p className="generate-modal-template-reason">
                                                                <FaIcon iconName="circle-info"/> {template.incompatible_reasons[0]}
                                                            </p>
                                                        )}
                                                    </div>
                                                    {isSelected && (
                                                        <div className="generate-modal-template-check">
                                                            <FaIcon iconName="circle-check"/>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}

                                        {this.state.userTemplates.length > 0 && (
                                            <>
                                                <div className="generate-modal-templates-section-header">
                                                    {t('templates.picker_section_user')}
                                                </div>
                                                {this.state.userTemplates.map(ut => {
                                                    const isSelected = selectedUserTemplateId === ut.id;
                                                    return (
                                                        <div key={ut.id}
                                                             className={`generate-modal-template-card ${isSelected ? '-selected' : ''}`}
                                                             onClick={() => this.handleSelectUserTemplate(ut.id)}>
                                                            <div className="generate-modal-template-icon">
                                                                <FaIcon iconName="file-chart-line"/>
                                                            </div>
                                                            <div className="generate-modal-template-content">
                                                                <h4 className="generate-modal-template-name">{ut.name}</h4>
                                                                <p className="generate-modal-template-desc">{ut.description}</p>
                                                                <div className="generate-modal-template-meta">
                                                                    <span className="generate-modal-template-meta-badge -custom">
                                                                        <FaIcon iconName="pen-to-square"/>
                                                                        {ut.is_shared ? t('templates.badge_shared') : t('templates.badge_custom')}
                                                                    </span>
                                                                    {ut.created_by && ut.created_by.id !== LocalStorage.fetchUserId() && (
                                                                        <span className="generate-modal-template-meta-scope">
                                                                            {t('templates.by_author', {name: ut.created_by.name})}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {isSelected && (
                                                                <div className="generate-modal-template-check">
                                                                    <FaIcon iconName="circle-check"/>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        {selectedClientId && selectedTemplateSlug && !selectedUserTemplateId && (() => {
                            const tmpl = this.state.templates.find(t => t.slug === selectedTemplateSlug);
                            if (!tmpl || !tmpl.allows_item_selection) return null;
                            if (this.state.loadingClientData) {
                                return (
                                    <div className="generate-modal-section" style={{display: 'flex', justifyContent: 'center', padding: '1.5em 0'}}>
                                        <Spinner color="positive" size="sm"/>
                                    </div>
                                );
                            }
                            if (!this.state.clientData) return null;
                            return (
                                <div className="generate-modal-section">
                                    <ReportContextSelector
                                        template={tmpl}
                                        adAccounts={this.state.clientData.ad_accounts || []}
                                        businessUnits={this.state.clientData.business_units || []}
                                        onScopeChange={this.handleScopeChange}
                                    />
                                </div>
                            );
                        })()}

                        {selectedClientId && !LocalStorage.isClientUser() && (
                            <div className="generate-modal-section -visibility">
                                <div className="generate-modal-visibility-row">
                                    <div className="generate-modal-visibility-text">
                                        <span className="generate-modal-visibility-label">{t('reports.visible_to_clients_label')}</span>
                                        <span className="generate-modal-visibility-hint">{t('reports.visible_to_clients_hint')}</span>
                                    </div>
                                    <Switch
                                        name="visibleToClients"
                                        checked={this.state.visibleToClients}
                                        onChange={(e) => this.setState({visibleToClients: e.target.checked})}
                                        style={{margin: 0}}
                                    />
                                </div>
                                <div className="generate-modal-visibility-row -public-link">
                                    <div className="generate-modal-visibility-text">
                                        <span className="generate-modal-visibility-label">{t('reports.public_link_label')}</span>
                                        <span className="generate-modal-visibility-hint">{t(this.state.isPublic ? 'reports.public_link_hint' : 'reports.public_link_off_hint')}</span>
                                    </div>
                                    <Switch
                                        name="isPublic"
                                        checked={this.state.isPublic}
                                        onChange={(e) => this.setState({isPublic: e.target.checked})}
                                        style={{margin: 0}}
                                    />
                                </div>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter className="all-reports-generate-modal-footer">
                        <button className="btn -negative" onClick={this.toggleGenerateModal}>
                            {t('client_reports.cancel')}
                        </button>
                        <button
                            className="btn -alt"
                            onClick={this.handleGenerate}
                            disabled={!selectedClientId || !hasSelection || generating || this.state.showWizard}
                        >
                            <FaIcon iconName="wand-magic-sparkles"/>
                            {this.state.showWizard
                                ? t('report_wizard.checking')
                                : (generating ? t('client_reports.generating') : t('reports.generate_report'))}
                        </button>
                    </ModalFooter>
                    {this.state.showWizard && (
                        <ReportPreGenerationWizard
                            clientId={selectedClientId}
                            scope={this.state.scope}
                            selectedTemplate={this.state.templates.find(t => t.slug === this.state.selectedTemplateSlug)}
                            onValidationComplete={() => this.proceedWithGenerate()}
                            onCancel={() => this.setState({showWizard: false})}
                        />
                    )}
                </Modal>

                <Modal isOpen={showSuccessModal} toggle={this.toggleSuccessModal} className="client-reports-success-modal">
                    <ModalHeader toggle={this.toggleSuccessModal}>
                        {t('client_reports.success_title')}
                    </ModalHeader>
                    <ModalBody className="client-reports-success-modal-body">
                        {t('client_reports.success_message')}
                    </ModalBody>
                    <ModalFooter className="client-reports-success-modal-footer">
                        <button className="btn -alt" onClick={this.toggleSuccessModal}>
                            {t('client_reports.success_ok')}
                        </button>
                    </ModalFooter>
                </Modal>

                <ClientProfileSidePanel
                    isOpen={!!this.state.profilePanelClientId}
                    clientId={this.state.profilePanelClientId}
                    clientName={this.state.profilePanelClientName}
                    onClose={this.closeProfilePanel}
                />
            </div>
        );
    }
}

export const AllReportsPage = withTranslation()(AllReportsPageClass);
